<div class="toolbar">
    <div class="toolbar-section">
        <div class="app-title">
            <span class="app-icon">🎨</span>
            <h1>Canvas Editor</h1>
        </div>
    </div>

    <div class="toolbar-section">
        <div class="button-group">
            <button class="toolbar-button" (click)="goBack()" title="Back to previous page">
                <span class="button-icon">⬅️</span>
                <span class="button-label">Back</span>
            </button>
            <button class="toolbar-button" (click)="saveAndContinue()" title="Save & Continue">
                <span class="button-icon">💾</span>
                <span class="button-label">Save & Continue</span>
            </button>
        </div>
    </div>

    <div class="toolbar-section">
        <div class="button-group">
            <div class="dropdown canvas-size-dropdown" #canvasSizeDropdown [class.open]="isCanvasSizeMenuOpen()">
                <button class="toolbar-button canvas-size-btn" title="Canvas Size" (click)="toggleCanvasSizeMenu($event)">
                    <span class="button-icon">📐</span>
                    <span class="button-label">{{ getCurrentSizeName() }}</span>
                </button>
                <div class="dropdown-content canvas-size-menu" (click)="keepCanvasSizeMenuOpen($event)">
                    @if (isCustomSize()) {
                        <div class="custom-size-panel">
                            <div class="custom-size-title">Custom size</div>
                            <div class="custom-size-grid">
                                <label>
                                    W
                                    <input
                                        type="number"
                                        min="1"
                                        [value]="customWidthInput()"
                                        (input)="updateCustomSize('width', $event)"
                                        (blur)="resetCustomSizeInput('width')"/>
                                </label>
                                <label>
                                    H
                                    <input
                                        type="number"
                                        min="1"
                                        [value]="customHeightInput()"
                                        (input)="updateCustomSize('height', $event)"
                                        (blur)="resetCustomSizeInput('height')"/>
                                </label>
                            </div>
                        </div>
                    }
                    <div class="canvas-size-list">
                        @for (size of canvasSizes; track size.type) {
                            <button (click)="setCanvasSize(size.type)"
                                [class.active]="canvasService.canvasSizeTypeValue() === size.type">
                                {{ size.name }}
                                @if (size.type === 'custom') {
                                    <small>{{ customSize().width }} × {{ customSize().height }} px</small>
                                } @else if (size.unit) {
                                    <small>{{ size.unit }}</small>
                                }
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="toolbar-section">
        <div class="button-group">
            <button class="toolbar-button" (click)="newCanvas()" title="New Canvas">
                <span class="button-icon">📄</span>
                <span class="button-label">New</span>
            </button>

            <div class="dropdown hover-dropdown">
                <button class="toolbar-button" title="Import">
                    <span class="button-icon">📥</span>
                    <span class="button-label">Import</span>
                </button>
                <div class="dropdown-content">
                    <button (click)="importJSON()">Import JSON</button>
                    <button (click)="importImage()">Import Image</button>
                    <button (click)="importSVG()">Import SVG</button>
                </div>
            </div>

            <div class="dropdown hover-dropdown">
                <button class="toolbar-button" title="Export">
                    <span class="button-icon">📤</span>
                    <span class="button-label">Export</span>
                </button>
                <div class="dropdown-content">
                    <button (click)="exportJSON()">Export JSON</button>
                    <button (click)="exportSVG()">Export SVG</button>
                    <button (click)="exportPNG()">Export PNG</button>
                    <button (click)="exportPDF()">Export PDF</button>
                </div>
            </div>
        </div>
    </div>

    <div class="toolbar-section">
        <div class="button-group">
            <button class="toolbar-button" (click)="canvasService.undo()" [disabled]="!canUndo()" title="Undo (Cmd+Z)">
                <span class="button-icon">↶</span>
            </button>
            <button class="toolbar-button" (click)="canvasService.redo()" [disabled]="!canRedo()"
                title="Redo (Cmd+Shift+Z)">
                <span class="button-icon">↷</span>
            </button>
        </div>
    </div>

    <input #fileInput type="file" accept="image/*,.svg,.json" style="display: none" (change)="onFileSelected($event)" />
